import React, { PureComponent, useState } from 'react';
import StreamField from '../../components/StreamField';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { basePageWrap } from '../BasePage';
import s from './NewsPage.module.scss';
import ButtonSecondary from '../../components/ButtonSecondary';
import RelatedContent from '../../components/RelatedContent';
import Modal from '../../components/Modal/Modal';
import HeroRichText from '../../components/HeroRichText/HeroRichText';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import HeroNews from '../../components/HeroNews/HeroNews';

const NewsPage = ({
  hero,
  category,
  lastUpdated,
  contentBlocks,
  relatedContent = {},
  isDesktop,
  breadcrumbs,
}) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const rootClasses = classNames(s.Root, {});
  const wrapperClasses = classNames(s.Wrapper, {});
  const footerClasses = classNames(s.Footer, {});

  const share = {
    title: hero?.titleTop + ' ' + hero?.titleBottom,
    onClose: () => setShowModal(false),
    onClick: () => setShowModal(true),
    isVisible: showModal,
    url: '',
  };

  return (
    <>
      <div className={rootClasses}>
        {breadcrumbs && <Breadcrumb {...breadcrumbs} />}
        <HeroNews
          share={share}
          category={category}
          lastUpdated={lastUpdated}
          {...hero}
        />
        <div className={wrapperClasses}>
          <section className={s.Container}>
            <div className={s.StreamField}>
              <StreamField items={contentBlocks} fromNewsPage />
            </div>
          </section>
          {/* {!!relatedContent?.titleTop && (
            <RelatedContent {...relatedContent} isDesktop={isDesktop} />
          )} */}
        </div>
      </div>

      {showModal && <Modal {...share} />}
    </>
  );
};

export default basePageWrap(NewsPage);

NewsPage.propTypes = {
  titleTop: PropTypes.string,
  titleBottom: PropTypes.string,
  text: PropTypes.string,
  image: PropTypes.object,
  blocks: PropTypes.array,
  lastUpdated: PropTypes.string,
};

NewsPage.defaultProps = {
  titleTop: '',
  titleBottom: '',
  text: '',
  image: {},
  blocks: [],
  lastUpdated: '',
};
